import { useState } from 'react'
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { ListGrade, GradeForm } from "../../../components/Admin/Grade";
import "./Grade.scss";

export function Grade() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListGrade reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="grade-page">
        <Button className="grade-page__add" primary onClick={onOpenCloseModal}>
          Nuevo grado
        </Button>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title="Crear grado">
        <GradeForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  )
}
